import React from 'react';
import { NavBar, Footer } from '../components/Layout';

const photos = [
  {
    src: '/highlights/public-speaking.webp',
    alt: 'Speaking into a microphone during the Universidad de Cartagena alumni panel',
    caption: 'In conversation at the alumni panel',
    width: 960,
    height: 1280,
  },
  {
    src: '/highlights/on-stage.webp',
    alt: 'Four participants standing on stage beside a podium',
    caption: 'A moment on stage',
    width: 960,
    height: 1280,
  },
];

export default function PublicSpeaking() {
  return (
    <div className="min-h-screen bg-white text-apple-gray-800">
      <NavBar />
      <main className="max-w-5xl mx-auto px-6 lg:px-8 pt-28 pb-20">
        <header className="max-w-2xl mb-10">
          <p className="text-sm font-semibold uppercase tracking-widest text-apple-gray-600 mb-3">Journey &amp; impact</p>
          <h1 className="text-4xl md:text-5xl font-bold mb-5">20 years of Systems Engineering</h1>
          <p className="text-lg font-semibold mb-5">Universidad de Cartagena · Faculty of Engineering · 2026</p>
          <p className="text-lg md:text-xl text-apple-gray-600 leading-relaxed">
            I joined the alumni panel celebrating the 20th anniversary of the Systems Engineering program at Universidad de Cartagena. The event brought alumni together to reconnect, share experiences, and celebrate the generations of professionals who have helped shape the program.
          </p>
          <h2 className="text-2xl font-semibold mt-8 mb-3">AI and the evolution of software careers</h2>
          <p className="text-lg text-apple-gray-600 leading-relaxed">
            The panel explored how the software industry is adapting to artificial intelligence, and how professional profiles and roles are evolving alongside it.
          </p>
        </header>

        <figure className="mb-10">
          <img
            src="/highlights/auditorium.webp"
            alt="Attendees gathered together in a full auditorium"
            width="1280"
            height="853"
            className="w-full h-auto rounded-2xl"
          />
          <figcaption className="mt-3 text-apple-gray-600">Together in the auditorium</figcaption>
        </figure>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
          {photos.map(photo => (
            <figure key={photo.src}>
              <img
                src={photo.src}
                alt={photo.alt}
                width={photo.width}
                height={photo.height}
                loading="lazy"
                decoding="async"
                className="w-full h-auto rounded-2xl"
              />
              <figcaption className="mt-3 text-apple-gray-600">{photo.caption}</figcaption>
            </figure>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
